import UsersManagement from "views/dashboard/UsersManagement";
import UsersFeedback from "views/dashboard/UsersFeedback";
import OrdersManagement from "views/dashboard/OrdersManagement";
import AskSalahOrdersManagement from "views/dashboard/AskSalahOrdersManagement";
import BioFlowOrdersManagement from "views/dashboard/BioFlowOrdersManagement";
import ModelManagement from "views/dashboard/ModelManagement";

const routes: { exact: boolean; component: any; path: string }[] = [
  {
    exact: true,
    component: UsersManagement,
    path: "/users",
  },
  {
    exact: true,
    component: UsersFeedback,
    path: "/usersFeedback",
  },
  {
    exact: true,
    component: OrdersManagement,
    path: "/orders",
  },
  {
    exact: true,
    component: AskSalahOrdersManagement,
    path: "/ask-salah-orders",
  },
  {
    exact: true,
    component: BioFlowOrdersManagement,
    path: "/bioflow-orders",
  },
  {
    exact: true,
    path: "/cms/:model",
    component: ModelManagement,
  },
];
export default routes;
